import { PrimaryButton } from '../learn_buttons.tsx';
import { PromptSubtext, ScreenBody, ScreenPrompt, Slack } from '../learn_screen_parts.tsx';

export const rangePermissionScreenId = 'range-permission';
export const rangeContinueButtonId = 'range-continue-button';

export const permissionPrompt = 'Mind if we listen to you sing?';
export const permissionSubtext = 'Nothing is saved or uploaded';

// Step 1 of the Range Finder (issues #3481, #3510, #3585): one large prompt asking to listen and
// the one line of reassurance the issue allows under it. No explanation paragraph and no meter.
// Issue #3510 also drew a picture of the permission dialog about to appear, with an arrow at Allow;
// issue #3585 removed it because some singers took the picture for the real dialog and tapped it.
// The Continue tap is the user gesture that resumes audio and requests the mic, which is why it is
// a real button: this screen is the fallback for a microphone the page cannot open on its own (see
// "Permission" in range_finder_page.tsx). A singer whose browser has already granted the microphone
// never sees it, and one whose open is waiting for a gesture sees it a moment late and finishes
// that same open by tapping Continue. The prompt takes no character cap, so it uses whatever width
// the body gives it rather than breaking mid-question on a screen with room to spare.
export const RangePermissionScreen = ({ onContinue }: { onContinue: () => void }) => (
  <ScreenBody id={rangePermissionScreenId}>
    <ScreenPrompt>{permissionPrompt}</ScreenPrompt>
    <PromptSubtext>{permissionSubtext}</PromptSubtext>
    <Slack />
    <PrimaryButton id={rangeContinueButtonId} data-testid={rangeContinueButtonId} onClick={onContinue}>
      Continue
    </PrimaryButton>
  </ScreenBody>
);
